import React from 'react';
import CustomDeletePage from 'components/custom-pages/CustomDelete';

const Delete = ({ data, handleClick }) => {
  return (
    <CustomDeletePage
      pageTitle={'Delete Inspection Observation'}
      url={'inspection-observation'}
      queryKey="inspection-observation"
      title={'Inspection Observation'}
      id={data?._id}
      handleClick={handleClick}
    />
  );
};

export default Delete;
